export default {"src":"/_next/static/media/Instagram.0659e6d3.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};